<template>
    <div class="section-box">
        <div class="customer-list">
            <el-row class="customer-row-bg">
                <el-col :span="12" style="text-align: left;display: flex;align-items: center;">
                    <el-form :inline="true" label-width="90px" label-position="left">
                        <el-form-item size="medium">
                            <el-button size="mini" :class="{'selected':form.Status===''||typeof(form.Status) === 'undefined'}" style="margin-right: 15px;" @click="handleSearchType()">全部</el-button>
                            <el-badge :value="count" :max="99" style="margin-right: 15px;" :hidden="count<=0">
                                <el-button size="mini" :class="{'selected':form.Status===1}" @click="handleSearchType(1)">已上线</el-button>
                            </el-badge>
                            <el-button size="mini" style="margin-right: 15px;" :class="{'selected':form.Status===2}" @click="handleSearchType(2)">未上线</el-button>
                            <el-button size="mini" style="margin-right: 15px;" :class="{'selected':form.Status===0}" @click="handleSearchType(0)">已删除</el-button>
                        </el-form-item>
                    </el-form>
                </el-col>
                <el-col :span="12" style="text-align: right">
                    <el-button size="medium" type="primary" icon="el-icon-plus" plain @click="linkListInfoFun(0)">新建</el-button>
                    <el-button size="medium" type="primary" @click="handleSearch">查询</el-button>
                    <el-button size="medium" type="success" @click="handleReset">重置</el-button>
                </el-col>
            </el-row>
        </div>
        <!-- 列表 -->
        <el-table
            ref="tableData"
            :stripe="true"
            :data="tableData"
            border
            style="width: 100%;margin-top: 20px;"
            height="640"
            v-loading="listLoading" 
            >
            <!-- eslint-disable  -->
            <el-table-column label="奖品编号">
                <el-table-column show-overflow-tooltip>
                    <template slot="header" slot-scope="scope">
                        <el-input size="mini" v-model.trim="form.Id" placeholder="输入关键字搜索"/>
                    </template>
                    <template slot-scope="scope">
                        <span>{{scope.row.Id || '--'}}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="奖品名称">
                <el-table-column show-overflow-tooltip>
                    <template slot="header" slot-scope="scope">
                        <el-input size="mini" v-model.trim="form.PrizeName" placeholder="输入关键字搜索"/>
                    </template>
                    <template slot-scope="scope">
                        <span>{{scope.row.PrizeName || '--'}}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="奖品分类">
                <el-table-column show-overflow-tooltip>
                    <template slot="header" slot-scope="scope">
                        <el-select size="mini" v-model.trim="form.MaterialObject" placeholder="请选择" style="width: 100%;">
                            <el-option 
                                v-for="(item, index) in MaterialObjectArr" 
                                :key="index"
                                :value="item.JobStatus" 
                                :label="item.JobStatusTxt" 
                            >
                            </el-option>
                        </el-select>
                    </template>
                    <template slot-scope="scope">
                        <span>{{scope.row.IsMaterialObject?'实物':'虚物'}}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="所需积分">
                <el-table-column show-overflow-tooltip>
                    <template slot="header" slot-scope="scope">
                        <el-input size="mini" v-model="form.MinScore" style="width: 45%;" placeholder="搜索最小值" type="number"/> ~
                        <el-input size="mini" v-model="form.MaxScore" style="width: 45%;" placeholder="搜索最大值" type="number"/>
                    </template>
                    <template slot-scope="scope">
                        <span v-if="scope.row.PrizeType == 1">{{scope.row.ExtAttributeValue || '--'}}</span>
                        <span v-else>--</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="状态">
                <el-table-column show-overflow-tooltip>
                    <template slot="header" slot-scope="scope">
                        <el-select size="mini" v-model.trim="form.Status" placeholder="请选择" style="width: 100%;">
                            <el-option 
                                v-for="(item, index) in statusArr" 
                                :key="index"
                                :value="item.JobStatus" 
                                :label="item.JobStatusTxt" 
                            >
                            </el-option>
                        </el-select>
                    </template>
                    <template slot-scope="scope">
                        <span v-if="scope.row.Status == 1">已上线</span>
                        <span v-else-if="scope.row.Status == 2">未上线</span>
                        <span v-else>已删除</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="操作">
                <template slot-scope="scope">
                    <template v-if="scope.row.Status == 1">
                        <!-- 上线的时候显示下线 -->
                        <el-button size="mini" type="warning" @click="setConfigPublishOrDel(scope.row.Id,2)">下线</el-button>
                    </template>
                    <template v-else-if="scope.row.Status == 2">
                        <!-- 下线的时候显示上线 删除 编辑 -->
                        <el-button size="mini" @click="linkListInfoFun(scope.row.Id,scope.row)">编辑</el-button>
                        <el-button size="mini" type="primary" @click="setConfigPublishOrDel(scope.row.Id,1)">上线</el-button>
                        <el-button size="mini" type="danger" @click="setConfigPublishOrDel(scope.row.Id,0)">删除</el-button>
                    </template>
                    <template v-else>
                        <!-- 在删除里显示恢复 -->
                        <el-button size="mini" @click="linkListInfoFun(scope.row.Id,scope.row)">编辑</el-button>
                        <el-button size="mini" v-if="isRestore" type="success" @click="setConfigPublishOrDel(scope.row.Id,2)">恢复</el-button>
                    </template>
                </template>
            </el-table-column>
        </el-table>
        <div style="margin: 10px;overflow: hidden">
            <div style="float: right;" v-show="tableData.length">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="form.PageNum"
                    :page-sizes="[10, 20, 50, 100, 200]"
                    :page-size="form.PageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="total">
                </el-pagination>
            </div>
        </div>

        <el-dialog 
            :visible.sync="showAdd"
            :title="dialogTitle"
            width="30%"
        >
            <el-form :model="ruleForm" ref="ruleForm" label-width="100px" class="demo-ruleForm">
                <el-form-item label="奖品名称：" required>
                    <el-input v-model.trim="ruleForm.PrizeName" maxlength="50"></el-input>
                </el-form-item>
                <el-form-item label="奖品分类：" required>
                    <el-radio-group v-model="ruleForm.IsMaterialObject">
                        <el-radio :label="true">实物</el-radio>
                        <el-radio :label="false">虚拟物品</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="所需积分：" required>
                    <el-input v-model.number="ruleForm.ExtAttributeValue" onpaste="return false" @keyup.native="blurText($event)" maxlength="10"></el-input>
                </el-form-item>
                <el-form-item label="奖品图：" required class="mask">
                    <el-upload 
                        class="show" 
                        :class="{ hide: hideUploadCover }" 
                        :action="url" 
                        list-type="picture-card"
                        :limit="1" 
                        :file-list="fileListCover" 
                        :on-change="dealImgChangeCover"
                        :on-remove="handleDealImgRemoveCover" 
                        :on-success="handleAvatarSuccessCover"
                        :on-preview="handlePictureCardPreview" 
                        accept=".jpg, .jpeg, .png"
                        :before-upload="uploadPreview"
                    >
                            <i class="el-icon-plus"></i>
                    </el-upload>
                    <span class="tips">注:请上传图片格式,大小不超过5MB</span>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="save()">保存</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>

        <el-dialog :visible.sync="dialogVisible" :close-on-click-modal="false">
            <img width="100%" :src="dialogImageUrl" alt="" />
        </el-dialog>
    </div>
</template>
<script>
/* eslint-disable */
    import {
        GetPrizeStatus,     //获取列表状态
        GetPrizeList,       //获取列表
        SetPrizeStatus,     //设置奖品上线、下线、删除、恢复
        SetSortNo,          //拖拽上移下移
        SavePrize,          //保存奖品
    } from "@/service/run";
    import { 
        getStorageUserRoleId,
        getActionData
    } from '@/utils/store'
    import Sortable from "sortablejs";
    import apiEnv from "@/service/apiEnv.js";
    export default {
        components: {
            Sortable
        },
        data() {
            return {
                actionData: JSON.parse(getActionData()),      //功能按钮每个页面必须用
                listLoading: false,
                form: {
                    PageNum: 1,
                    PageSize: 10,
                    Id: '',              //奖品编号
                    PrizeName: '',      //奖品名称
                    MaterialObject: '',  //奖品类别 0全部 1实物 2虚物

                    MinScore: '',        //所需积分 最小值
                    MaxScore: '',        //所需积分 最大值
                    Status: '',         //状态 -1全部 0删除 1上线 2未上线
                },
                
                searchData:{},
                oraginForm:{},
                total: 0,                       //总条数
                tableData:[],
                isRestore: false,
                MaterialObjectArr:[
                    {
                        JobStatus: 1,
                        JobStatusTxt: '实物'
                    },
                    {
                        JobStatus: 2,
                        JobStatusTxt: '虚物'
                    },
                ],

                statusArr:[                     //状态
                    {
                        JobStatus: 1,
                        JobStatusTxt: '已上线'
                    },
                    {
                        JobStatus: 2,
                        JobStatusTxt: '未上线'
                    },
                    {
                        JobStatus: 0,
                        JobStatusTxt: '已删除'
                    }
                ], 
                count: 0,           //上心table数量

                showAdd: false,
                dialogTitle: '新建',

                url: apiEnv.uploadURL,
                ruleForm: {
                    Id: 0,                      //添加传0 修改传id
                    PrizeName: "",              //奖品名称
                    IsMaterialObject: '',    //是否是实物
                    ExtAttributeValue:'',       //所需积分
                },
                //s上传
                hideUploadCover: false,
                fileListCover: [],
                dialogVisible: false,
                dialogImageUrl: "", //封面图
                limitCount: 1,
                DialogsImageUrlCover: [],
            };
        },
        activated(){
            this.handleSearch()
        },
        mounted(){
            this.rowDrop()
        },
        created() {
            this.tableData = [];
            this.oraginForm = JSON.parse(JSON.stringify(this.form))
            this.handleSearch();
            this.GetPrizeStatus();
            
        },
        methods: {
            // 获取列表状态
            GetPrizeStatus(){
                GetPrizeStatus().then(res=> {
                    this.$nextTick(()=>{
                        res.Data.PrizeStatusList.map(obj=>{
                            if(obj.StatusCode == 1) {
                                return  this.count = obj.Count
                            }
                        })
                    })
                })
            },
            // 分类
            handleSearchType(type){
                if(type === 0) {
                    this.isRestore = true
                }else {
                    this.isRestore = false
                }
                this.form.Status = type
                this.handleSearch()
            },
            // 查询
            handleSearch() {
                this.searchData = Object.assign({}, this.form)
                this.handleCurrentChange(1)
            },
            // 重置
            handleReset() {
                this.form = JSON.parse(JSON.stringify(this.oraginForm))
                this.handleSearch()
            },
            handleSizeChange(val) {
                if (this.listLoading) return
                this.form.PageNum = 1
                this.form.PageSize = val
                this.searchData.PageNum = 1
                this.searchData.PageSize = val
                this.GetPrizeListFun()
            },
            handleCurrentChange(val) {
                if (this.listLoading) return
                this.form.PageNum = val
                this.searchData.PageNum = val
                this.GetPrizeListFun()
            },
            //获取我的客户列表
            async GetPrizeListFun(){
                this.listLoading = true
                let data = JSON.parse(JSON.stringify(this.searchData))
                !data.Id && delete data.Id
                !data.PrizeName && delete data.PrizeName
                if(data.MaterialObject === '') data.MaterialObject = 0
                !data.MinScore && delete data.MinScore
                !data.MaxScore && delete data.MaxScore
                if(data.Status === '') data.Status = -1
                let res = await GetPrizeList(data)
                this.listLoading = false
                if(res.Result != 1) {
                    return this.$message.error('获取失败请联系开发人员')
                }
                this.tableData = res.Data.PrizeList || []
                this.total = res.Data.TotalCount
                this.$nextTick(()=>{
                    this.$refs.tableData.doLayout()
                })
            },
            

            // 删除 发布 取消发布
            setConfigPublishOrDel(id,type){
                let data = {}
                data.Id = id
                data.Status = type
                SetPrizeStatus(data).then(res=> {
                    if(res.Result != 1) {
                        return this.$message.error(res.Message)
                    }
                    this.$message.success('操作成功！')
                    this.GetPrizeListFun();
                    this.GetPrizeStatus();
                })
            },


            // 拖拽
            rowDrop() {
                const tbody = document.querySelector(".el-table__body-wrapper tbody");
                const _this = this
                Sortable.create(tbody, {
                    animation: 150,
                    onEnd ({ newIndex, oldIndex }) {
                        if(newIndex == oldIndex) return
                        
                        let data = {}
                        if(oldIndex>newIndex) {
                            //上移
                            data.MoveCount = (oldIndex-newIndex)+1
                        }else{
                            // 下移
                            data.MoveCount = (oldIndex-newIndex)-1
                        }
                        data.Id = _this.tableData[oldIndex].Id
                        data.RowNum = newIndex
                        data.PageNum = _this.form.PageNum
                        data.PageSize = _this.form.PageSize
                        SetSortNo(data).then(res=> {
                            if(res.Result != 1) {
                                return _this.$message.error('操作失败！')
                            }
                            _this.$message.success('操作成功！')
                            _this.tableData.splice(newIndex, 0, _this.tableData.splice(oldIndex, 1)[0]);
                            var newArray = _this.tableData.slice(0);
                            _this.tableData = [];
                            _this.$nextTick(function () {
                                _this.tableData = newArray;
                            });
                        })
                    }
                })
            },


            //s上传
            uploadPreview(file) {
                const isLt5M = file.size / 1024 / 1024 < 5;

                
                if (!isLt5M) {
                this.$message.error('上传图片大小不能超过 5MB!');
                }
                return isLt5M;
            },
            dealImgChangeCover(file, fileList) {
                this.hideUploadCover = fileList.length >= this.limitCount;
            },
            //删除上传文件Cover
            handleDealImgRemoveCover(file, fileList) {
                this.DialogsImageUrlCover = []
                this.hideUploadCover = fileList.length >= this.limitCount;
                this.fileListCover = fileList;
                for(var i=0;i<fileList.length;i++){
                    this.DialogsImageUrlCover.push(fileList[i].response.Data[0].imgUrl)
                }
                
            },
            //上传成功Cover
            handleAvatarSuccessCover(res, file, fileList) {
                this.DialogsImageUrlCover = []
                if (res.Result != 1) {
                    this.fileListCover = [];
                    return this.$message.error(res.Message);
                }
                this.fileListCover = fileList;
                for(var i=0;i<fileList.length;i++){
                    this.DialogsImageUrlCover.push(fileList[i].response.Data[0].imgUrl)
                }
            },
            //点击图片查看
            handlePictureCardPreview(file) {
                this.dialogImageUrl = "";
                this.dialogImageUrl = file.response ?
                    file.response.Data[0].imgUrl :
                    file.url;
                this.dialogVisible = true;
            },
            //e上传

            // 点击新建或编辑
            // 跳转到客户信息
            linkListInfoFun(id,row) {
                if(id == 0) {
                    this.dialogTitle = '新建'
                    this.ruleForm = {
                        Id: 0,                      //添加传0 修改传id
                        PrizeName: "",              //奖品名称
                        IsMaterialObject: '',    //是否是实物
                        ExtAttributeValue:'',       //所需积分
                    }
                    this.fileListCover = []
                    this.DialogsImageUrlCover = []
                    this.hideUploadCover = false
                } else {
                    this.dialogTitle = '编辑'
                    this.ruleForm = {
                        Id:id,
                        PrizeName:row.PrizeName,
                        IsMaterialObject:row.IsMaterialObject,
                        ExtAttributeValue:row.ExtAttributeValue,
                    }
                    this.fileListCover = []
                    this.fileListCover.push({
                        url:row.PrizeImgUrl
                    })
                    this.DialogsImageUrlCover=[row.PrizeImgUrl]
                    this.hideUploadCover = true;
                }
                this.showAdd = true
            },
            // 点击dialog保存
            save(){
                let data = JSON.parse(JSON.stringify(this.ruleForm))
                if(!data.PrizeName) {
                    return this.$message.warning('奖品名称不能为空！');
                }
                if(data.IsMaterialObject === '') {
                    return this.$message.warning('请选择奖品类型');
                }
                if(!data.ExtAttributeValue) {
                    return this.$message.warning('所需积分为正整数');
                }
                if(typeof(data.ExtAttributeValue) != 'number') {
                    return this.$message.warning("所需积分为正整数"); 
                }
                if(this.DialogsImageUrlCover instanceof Array && !this.DialogsImageUrlCover.length) {
                    return this.$message.warning('请上传奖品图');
                }
                data.PrizeImgUrl = this.DialogsImageUrlCover[0]
                SavePrize(data).then(res=> {
                    if(res.Result != 1) {
                        return this.$message.error(res.Message)
                    }
                    this.$message.success(res.Message)
                    this.showAdd = false
                    this.GetPrizeListFun()
                })
            },
            // 只能输入正整数
            blurText(e) {
                var keynum = window.event ? e.keyCode : e.which;
                // var keychar = String.fromCharCode(keynum)
                if(keynum == 189||keynum == 190||keynum == 110||keynum == 109) {
                    this.$message.warning('禁止输入小数以及负数')
                    e.target.value=''
                }
            },
        }
    };
</script>
<style lang="scss">
    .customer-list {
        position: relative;
        .next-button {
            position: absolute;
            right: 0;
            top: -56px;
        }
    }
    .customer-row-bg {
        padding: 20px 14px;
        background-color: #f9fafc;
        display: flex;
        align-items: center;
        .el-form-item {
            margin-bottom: 0 !important;
        }
        .selected {
            color: #409EFF;
            border-color: #c6e2ff;
            background-color: #ecf5ff;
        }
    }
    .hide .el-upload--picture-card {
        display: none;
    }
</style>